import { useQuery } from "@tanstack/react-query";
import api from "../api";

export function placesQueryKey(category) {
  return ["places", category];
}

async function fetchPlacesRequest(category) {
  const requestCategory = category === "Fast Foody" ? "FastFoody" : category;
  const res = await api.get(process.env.REACT_APP_FETCH_PLACES_URL + requestCategory);
  return res.data;
}

export function usePlacesQuery(category, options = {}) {
  return useQuery({
    queryKey: placesQueryKey(category),
    queryFn: () => fetchPlacesRequest(category),
    enabled: Boolean(category) && options.enabled !== false,
  });
}
